import { ServerMember } from "../classes/ServerMember.js";
import { hydrate } from "../hydration/index.js";
import { ClassCollection } from "./Collection.js";
/**
 * Collection of Server Members
 */
export class ServerMemberCollection extends ClassCollection {
    /**
     * Check if member exists by composite key
     * @param id Id
     * @returns Whether it exists
     */
    hasByKey(id) {
        return super.has(id.server + id.user);
    }
    /**
     * Get member by composite key
     * @param id Id
     * @returns Member
     */
    getByKey(id) {
        return super.get(id.server + id.user);
    }
    /**
     * check partial status by composite key
     * @param id Id
     * @returns Member
     */
    isPartialByKey(id) {
        return super.isPartial(id.server + id.user);
    }
    /**
     * Fetch server member by Id
     * @param serverId Server Id
     * @param userId User Id
     * @returns Message
     */
    async fetch(serverId, userId, force = false) {
        const member = this.get(serverId + userId);
        if (member && !force && !this.isPartial(serverId + userId))
            return member;
        const data = (await this.client.api.get(`/servers/${serverId}/members/${userId}`, {
            roles: false,
        }));
        if (member) {
            this.updateUnderlyingObject(serverId + userId, hydrate("serverMember", data, this.client, false));
            return member;
        }
        return this.getOrCreate(data._id, data);
    }
    /**
     * Get or create
     * @param id Id
     * @param data Data
     */
    getOrCreate(id, data) {
        if (this.hasByKey(id) && !this.isPartialByKey(id)) {
            return this.getByKey(id);
        }
        else {
            const instance = new ServerMember(this, id);
            this.create(id.server + id.user, "serverMember", instance, this.client, data);
            return instance;
        }
    }
    /**
     * Get or return partial
     * @param id Id
     */
    getOrPartial(id) {
        if (this.hasByKey(id)) {
            return this.getByKey(id);
        }
        else if (this.client.options.partials) {
            const instance = new ServerMember(this, id);
            this.create(id.server + id.user, "serverMember", instance, this.client, {
                id,
                partial: true,
            });
            return instance;
        }
    }
}
